export const getPolicySummarySelector = state =>
  state.accountData.accounts.policy_summary;
